import { render } from "./HelloWorld.vue?vue&type=template&id=29e78974&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=29e78974&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-29e78974"

export default script